import React from 'react';
import { ArrowUpRight } from 'lucide-react';
export function SubmitCTA() {
  return <section className="mx-auto max-w-3xl px-4 py-24 text-center sm:px-6 lg:px-8" data-id="element-155">
      <h2 className="text-3xl font-bold tracking-tight text-neutral-900 sm:text-4xl" data-id="element-156">
        Building an AI startup in India?
        <br data-id="element-157" />
        Get listed.
      </h2>
      <p className="mx-auto mt-4 max-w-xl text-lg text-neutral-500" data-id="element-158">
        Join the most comprehensive directory of Indian AI companies. It's free,
        fast, and helps you get discovered by investors and talent.
      </p>

      <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row" data-id="element-159">
        <a href="#" className="inline-flex h-11 items-center justify-center gap-2 rounded-lg bg-black px-8 text-sm font-medium text-white transition-colors hover:bg-neutral-800 focus:outline-none focus:ring-2 focus:ring-neutral-400 focus:ring-offset-2" data-id="element-160">
          Submit your startup
          <ArrowUpRight className="h-4 w-4" data-id="element-161" />
        </a>
        <a href="#" className="text-sm font-medium text-neutral-500 hover:text-neutral-900 transition-colors" data-id="element-162">
          View submission guidelines
        </a>
      </div>
    </section>;
}